// ═══════════════════════════════════════════════════════════════
// Cart Header Sync
// Updates cart count badge in header on load and after add-to-cart
// ═══════════════════════════════════════════════════════════════

(function () {
  'use strict';

  // Initialize cart count on page load
  function initCartCount() {
    updateCartCount();
  }

  // Fetch and update cart count from Shopify
  function updateCartCount() {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    fetch('/cart.js')
      .then(response => {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(cart => {
        badge.textContent = cart.item_count || 0;
      })
      .catch(error => {
        console.log('Cart count update failed:', error);
        // Silently fail - cart.js might not be available
      });
  }

  // Expose updateCartCount globally so 10batch-product-card.js can call it
  window.updateCartCount = updateCartCount;

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartCount);
  } else {
    initCartCount();
  }

  // Re-update on Shopify section changes (theme editor)
  if (window.Shopify && window.Shopify.designSystem) {
    document.addEventListener('shopify:section:load', initCartCount);
  }

  // Update cart count every 5 seconds (for when user adds to cart in another tab)
  setInterval(updateCartCount, 5000);
})();
